import { Container } from '@chakra-ui/react';
import React from 'react';

const Contact = () => {
    return (
        <Container maxW={'container.lg'}>
            
      </Container>
    );
};

export default Contact;